import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = {
  title: 'Política de Privacidad',
  sections: [{
    heading: 'Información que Recopilamos',
    text: 'Recopilamos únicamente la información necesaria para procesar tu compra, incluyendo tu nombre, dirección de correo electrónico y datos de pago. No almacenamos información de tarjetas de crédito en nuestros servidores.'
  }, {
    heading: 'Uso de la Información',
    text: 'Utilizamos tu información personal exclusivamente para: procesar tu pedido y entregarte el producto digital adquirido, enviarte comunicaciones relacionadas con tu compra, y mejorar nuestros servicios.'
  }, {
    heading: 'Protección de Datos',
    text: 'Implementamos medidas de seguridad técnicas y organizativas para proteger tu información personal contra acceso no autorizado, alteración, divulgación o destrucción.'
  }, {
    heading: 'Cookies',
    text: 'Nuestro sitio web puede utilizar cookies para mejorar tu experiencia de navegación. Puedes configurar tu navegador para rechazar cookies, aunque esto podría afectar algunas funcionalidades del sitio.'
  }, {
    heading: 'Tus Derechos',
    text: 'Tienes derecho a acceder, rectificar o eliminar tu información personal en cualquier momento. Para ejercer estos derechos, puedes contactarnos a través de los canales disponibles en nuestro sitio.'
  }, {
    heading: 'Cambios en esta Política',
    text: 'Nos reservamos el derecho de actualizar esta política de privacidad en cualquier momento. Los cambios serán publicados en esta página con la fecha de la última actualización.'
  }]
};
const termsContent = {
  title: 'Términos y Condiciones',
  sections: [{
    heading: 'Aceptación de los Términos',
    text: 'Al acceder y utilizar este sitio web y adquirir nuestros productos, aceptas estar sujeto a estos términos y condiciones de uso. Si no estás de acuerdo con alguno de estos términos, te recomendamos no utilizar nuestros servicios.'
  }, {
    heading: 'Producto Digital',
    text: 'El producto ofrecido es una guía digital en formato PDF. Una vez completada la compra, recibirás acceso inmediato al material. Debido a la naturaleza digital del producto, no se aceptan devoluciones una vez descargado el contenido.'
  }, {
    heading: 'Uso Personal',
    text: 'El contenido adquirido es para uso personal y no comercial. Queda prohibida la reproducción, distribución, modificación o reventa del material sin autorización expresa por escrito.'
  }, {
    heading: 'Descargo de Responsabilidad Médica',
    text: 'El contenido de esta guía es únicamente informativo y educativo. No sustituye el consejo, diagnóstico o tratamiento médico profesional. Consulta siempre a tu médico antes de comenzar cualquier programa de ejercicios, especialmente si tienes condiciones médicas preexistentes.'
  }, {
    heading: 'Limitación de Responsabilidad',
    text: 'No nos hacemos responsables de lesiones o daños que puedan resultar del uso de la información proporcionada en la guía. El usuario asume toda la responsabilidad por el uso que haga del contenido.'
  }, {
    heading: 'Propiedad Intelectual',
    text: 'Todo el contenido del sitio web y de la guía, incluyendo textos, imágenes, diseños y logotipos, está protegido por derechos de autor y es propiedad exclusiva de Liberación de Movimiento.'
  }]
};
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  useEffect(() => {
    if (activeModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [activeModal]);
  const content = activeModal === 'privacy' ? privacyContent : activeModal === 'terms' ? termsContent : null;
  return <>
      <footer className="bg-sage-dark text-sage-light py-8 text-center text-sm" data-id="element-49">
        <div className="max-w-6xl mx-auto px-4" data-id="element-50">
          <p data-id="element-51">
            © {new Date().getFullYear()} Liberación de Movimiento. Todos los
            derechos reservados.
          </p>
          <p className="mt-2 opacity-70 text-xs max-w-2xl mx-auto" data-id="element-52">
            Este producto no sustituye el consejo médico profesional. Consulta a
            tu médico antes de comenzar cualquier programa de ejercicios.
          </p>
          <div className="mt-4 flex justify-center gap-6" data-id="element-53">
            <button onClick={() => setActiveModal('privacy')} className="text-sage-light/70 hover:text-white transition-colors underline underline-offset-2" data-id="element-54">
              Política de Privacidad
            </button>
            <span className="text-sage-light/30" data-id="element-55">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-sage-light/70 hover:text-white transition-colors underline underline-offset-2" data-id="element-56">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Modal Overlay */}
      {activeModal && content && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={() => setActiveModal(null)} data-id="element-57">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" data-id="element-58" />

          {/* Modal */}
          <div className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[85vh] overflow-hidden flex flex-col animate-[fadeIn_0.2s_ease-out]" onClick={e => e.stopPropagation()} data-id="element-59">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-5 border-b border-sage-light/30 bg-cream" data-id="element-60">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-sage-dark" data-id="element-61">
                {content.title}
              </h2>
              <button onClick={() => setActiveModal(null)} className="w-9 h-9 rounded-full bg-sage-light/50 flex items-center justify-center text-sage-dark hover:bg-sage-light transition-colors" aria-label="Cerrar" data-id="element-62">
                <X size={18} data-id="element-63" />
              </button>
            </div>

            {/* Content */}
            <div className="overflow-y-auto px-6 py-6 space-y-6 font-body text-text-dark" data-id="element-64">
              <p className="text-sm text-text-muted" data-id="element-65">
                Última actualización:{' '}
                {new Date().toLocaleDateString('es-ES', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
              </p>
              {content.sections.map((section, idx) => <div key={idx} data-id="element-66">
                  <h3 className="text-lg font-bold text-sage-dark mb-2 font-heading" data-id="element-67">
                    {section.heading}
                  </h3>
                  <p className="text-text-muted leading-relaxed" data-id="element-68">
                    {section.text}
                  </p>
                </div>)}
            </div>

            {/* Footer */}
            <div className="px-6 py-4 border-t border-sage-light/30 bg-cream text-center" data-id="element-69">
              <button onClick={() => setActiveModal(null)} className="px-6 py-2.5 bg-sage text-white rounded-full text-sm font-semibold hover:bg-sage-dark transition-colors" data-id="element-70">
                Entendido
              </button>
            </div>
          </div>
        </div>}
    </>;
}